import { InstructionType } from 'app/src/engine/Instruction';
import HaltInstruction from 'app/src/engine/instructions/HaltInstruction';
import Instruction from 'app/src/engine/instructions/Instruction';
import MoveInstruction, { MoveInstructionType } from 'app/src/engine/instructions/MoveInstruction';
import RotateInstruction, {
	RotateInstructionType,
} from 'app/src/engine/instructions/RotateInstruction';

export default class InstructionFactory {
	public static getInstruction(type: InstructionType): Instruction {
		switch (type) {
			case InstructionType.Move1:
				return new MoveInstruction(MoveInstructionType.Move1);
			case InstructionType.Move2:
				return new MoveInstruction(MoveInstructionType.Move2);
			case InstructionType.Move3:
				return new MoveInstruction(MoveInstructionType.Move3);
			case InstructionType.BackUp:
				return new MoveInstruction(MoveInstructionType.BackUp);
			case InstructionType.TurnLeft:
				return new RotateInstruction(RotateInstructionType.TurnLeft);
			case InstructionType.TurnRight:
				return new RotateInstruction(RotateInstructionType.TurnRight);
			case InstructionType.UTurn:
				return new RotateInstruction(RotateInstructionType.UTurn);
			case InstructionType.Halt:
				return new HaltInstruction();
		}
	}
}
